<template id="modal-template">
    <transition v-if="show" name="modal" appear>
        <div class="modal-container">
            <div class="modal-wrapper">
                <div class="modal modal--7">
                    <div class="modal__head">
                        <h1 class="modal__title">쿠폰사용</h1>
                        <button class="modal__close" type="button" @click="close">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <path d="M0.222,1.636 L1.636,0.221 L15.778,14.363 L14.364,15.778 L0.222,1.636 Z" />
                                <path d="M14.364,0.221 L15.778,1.636 L1.636,15.778 L0.222,14.363 L14.364,0.221 Z" />
                            </svg>
                        </button>
                    </div>
                    <div class="modal__body">
                        <div
                            v-for="({ deliveryAmount, islandAmount, _store, shippingCode, usableCoupons, products, pickups }, i) in groups.filter(
                                ({ deliveryAmount, islandAmount }) => deliveryAmount + islandAmount
                            )"
                            :key="`delivery-group-${i}`"
                            class="modal-delivery-coupon-list"
                        >
                            <ul v-for="(product, j) in products" :key="`delivery-group${i}product-${j}`" class="delivery-group-info">
                                <li>
                                    <span class="product-name">{{ product.name }}</span>
                                </li>
                                <li v-for="(pickup, i) in pickups" :key="`delivery-group-item-${i}`">
                                    <span>옵션명: {{ pickup.name }}, 수량: {{ pickup.quantity.format() }}개</span>
                                </li>
                            </ul>
                            <div class="product-delivery">
                                <div>
                                    <div>
                                        <span>배송비</span>
                                        <strong>{{ deliveryAmount.format() }}</strong>
                                    </div>
                                    <div v-if="islandAmount">
                                        <span>도서산간추가배송비</span>
                                        <strong>{{ islandAmount.format() }}</strong>
                                    </div>
                                </div>
                                <div>
                                    <div style="color:rgb(191,0,0)">
                                        <template v-if="selected.some((coupon) => coupon._store == _store && coupon.shippingCode == shippingCode)">
                                            <span>쿠폰사용차감액</span>
                                            <strong>
                                                {{
                                                    $getCouponAmount(
                                                        selected.find((coupon) => coupon._store == _store && coupon.shippingCode == shippingCode),
                                                        deliveryAmount + islandAmount
                                                    ).format()
                                                }}
                                            </strong>
                                            원
                                        </template>
                                    </div>
                                    <div>
                                        <span>최종배송비</span>
                                        <strong>
                                            {{
                                                (selected.some((coupon) => coupon._store == _store && coupon.shippingCode == shippingCode)
                                                    ? deliveryAmount +
                                                      islandAmount -
                                                      $getCouponAmount(
                                                          selected.find((coupon) => coupon._store == _store && coupon.shippingCode == shippingCode),
                                                          deliveryAmount + islandAmount
                                                      )
                                                    : deliveryAmount + islandAmount
                                                ).format()
                                            }}
                                        </strong>
                                        원
                                    </div>
                                </div>
                            </div>
                            <ul class="use-coupon__list">
                                <li v-for="(coupon, k) in usableCoupons" :key="`delivery-coupon-${k}`">
                                    <label class="check">
                                        <input
                                            :checked="selected.includes(coupon) && coupon._store == _store && coupon.shippingCode == shippingCode"
                                            class="input"
                                            @change="select({ coupon, deliveryAmount, islandAmount, _store, shippingCode, products })"
                                            type="checkbox"
                                        />
                                        <i class="icon" />
                                        <span class="text">{{ coupon.name }}</span>
                                        <span class="num">
                                            <em>{{ coupon.amount.format() }}</em>
                                            {{ coupon.unit }}
                                        </span>
                                        <span class="coupon-condition" v-if="coupon.maxAmount || coupon.minAmount">
                                            (
                                            {{ coupon.minAmount ? `최소 ${coupon.minAmount}원 이상 구매 시` : "" }}
                                            {{ coupon.minAmount && coupon.maxAmount ? ", " : "" }}
                                            {{ coupon.maxAmount ? `최대 ${coupon.maxAmount.format()}원` : "" }}
                                            )
                                        </span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal__foot modal__foot--border">
                        <!-- <div>총 쿠폰사용 차감액 {{ totalCouponAmount }}</div> -->
                        <div class="modal__buttons modal__buttons--narrow">
                            <button class="button button--border-primary" type="button" @click="close()"><span>취소하기</span></button>
                            <button class="button button--primary" type="button" @click="confirm()"><span>쿠폰적용</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        value: { type: Array, default: null },
        coupons: { type: Array, default: null },
        carts: { type: Array, default: null },
        shippings: { type: Array, default: null },
        islands: { type: Array, default: null },
        postcode: { type: String, default: null },
    },
    data() {
        return {
            show: false,
            selected: [],
        };
    },
    computed: {
        groups() {
            const makeGroup = (cart) => ({
                _store: cart._store,
                shippingCode: cart.product.shipping.code,
                products: [],
                pickups: [],
                deliveryAmount: 0,
                islandAmount: 0,
                usableCoupons: [
                    ...this.coupons.map((coupon) => {
                        coupon.shippingCode = coupon.shippingCode || null;
                        coupon._store = coupon._store || null;
                        coupon._product = coupon._product || null;
                        coupon.deliveryAmount = coupon.deliveryAmount || null;
                        coupon.islandAmount = coupon.islandAmount || null;
                        return coupon;
                    }),
                ],
            });

            const getIsland = (_store) => this.islands.filter((island) => island._store == _store).find((island) => island.areas.find((area) => area.postcode == this.postcode)) || {};

            return this.carts
                .reduce((groups, cart) => {
                    let group = undefined;
                    switch (cart.product.shipping.code) {
                        case "product":
                        case "free":
                            group = makeGroup(cart);
                            group.products = [JSON.parse(JSON.stringify(cart.product))];
                            group.pickups = [...JSON.parse(JSON.stringify(cart.pickups))];
                            group.deliveryAmount = cart.product.shipping.price;
                            groups.push(group);
                            break;

                        case "order":
                            group = groups.find(({ _store, shippingCode }) => _store == cart._store && shippingCode == "order");

                            if (!group) {
                                group = makeGroup(cart);
                                groups.push(group);
                            }

                            group.products = [...group.products, JSON.parse(JSON.stringify(cart.product))];
                            group.pickups = [...group.pickups, ...JSON.parse(JSON.stringify(cart.pickups))];
                            group.saleAmount = (group.saleAmount || 0) + cart.pickups.reduce((saleAmount, pickup) => saleAmount + this.$getSaleAmount(pickup), 0);
                            break;
                    }
                    return groups;
                }, [])
                .map((group) => {
                    const { _store, saleAmount } = group;
                    if (saleAmount) {
                        const { baseAmount, greaterThen, lessThen } =
                            this.shippings.find((shipping) => shipping._store == _store && shipping.code == "order") ||
                            this.shippings.find((shipping) => shipping._store == undefined && shipping.code == "order");

                        group.deliveryAmount += baseAmount <= saleAmount ? greaterThen : lessThen;

                        const { enabled, price } = getIsland(group._store);
                        if (enabled) group.islandAmount += price;
                    } else {
                        if (group.products[0].islandEnabled && this.postcode) {
                            const { code } = getIsland(group._store);

                            group.islandAmount += group.products[0].island.groups.find((island) => island.code == code)?.price || 0;
                        }
                    }

                    return group;
                });
        },
        totalCouponAmount() {
            const { groups, selected, $getCouponAmount } = this;

            return selected.reduce((totalAmount, coupon) => {
                const { deliveryAmount, islandAmount } = groups.find(
                    (group) => group._store == coupon._store && group.shippingCode == coupon.shippingCode && (coupon.shippingCode == "product" ? group.products[0]._id == coupon._product : true)
                );

                return totalAmount + $getCouponAmount(coupon, deliveryAmount + islandAmount);
            }, 0);
        },
    },
    methods: {
        confirm() {
            this.$emit("input", JSON.parse(JSON.stringify(this.selected)));
            this.$emit("totalCouponAmount", this.totalCouponAmount);
            this.close();
        },
        select({ coupon, deliveryAmount, islandAmount, _store, shippingCode, products }) {
            const { selected } = this;

            const target = selected.find((__coupon) => __coupon !== coupon && __coupon._store == _store && __coupon.shippingCode == shippingCode);
            if (target) {
                target.shippingCode = null;
                target._store = null;
                target._product = null;
                target.deliveryAmount = null;
                target.islandAmount = null;
                selected.splice(selected.indexOf(target), 1);
            }

            if (selected.includes(coupon)) {
                if (coupon._store == _store && coupon.shippingCode == shippingCode) {
                    coupon.shippingCode = null;
                    coupon._store = null;
                    coupon._product = null;
                    coupon.deliveryAmount = null;
                    coupon.islandAmount = null;
                    selected.splice(selected.indexOf(coupon), 1);
                } else {
                    selected.splice(selected.indexOf(coupon), 1);
                    coupon._store = _store;
                    coupon.shippingCode = shippingCode;
                    coupon._product = null;
                    if (shippingCode == "product") coupon._product = products[0]._id;
                    coupon.deliveryAmount = deliveryAmount;
                    coupon.islandAmount = islandAmount;
                    selected.push(coupon);
                }
            } else {
                coupon._store = _store;
                coupon.shippingCode = shippingCode;
                coupon._product = null;
                if (shippingCode == "product") coupon._product = products[0]._id;
                coupon.deliveryAmount = deliveryAmount;
                coupon.islandAmount = islandAmount;
                selected.push(coupon);
            }
        },
        open() {
            this.show = true;
            document.querySelector("html").setAttribute("data-modal", "opened");
        },
        close() {
            this.show = false;
            document.querySelector("html").removeAttribute("data-modal");
        },
    },
};
</script>
<style lang="scss" scoped>
.modal-delivery-coupon-list {
    margin: 2rem 0;
    padding: 2rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    &:last-child {
        border-bottom: none;
    }

    ul,
    li {
        list-style: none;
    }

    .product-delivery {
        display: flex;
        justify-content: space-between;
        margin: 1rem 0;

        border-color: rgba(0, 0, 0, 0.15);

        strong {
            margin-left: 1rem;
        }

        > div {
            display: flex;
            flex-direction: column;
        }
    }

    .num {
        width: 20rem !important;

        em {
            padding: 0 6px;
            font-weight: bold;
        }
    }

    .coupon-condition {
        position: absolute;
        right: 20px;
        bottom: 0;
        color: rgba(0, 0, 0, 0.5);
    }

    .disabled-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
